import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ChillerDetail from '../../components/ac_central/ChillerDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import {
  getChiller,
  editChiller,
} from '../../redux/ac_central/chiller_actions';

class ACCentralEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ac !== nextProps.ac && nextProps.show) {
      this.props.getChiller(nextProps.ac.id);
    }
  }

  onSaveHandler() {
    const editedAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.editChiller({
      ...editedAC,
      id: this.props.ac.id,
    });
  }

  render() {
    const { isEditing, errorMessage, acDetail, t, getChiller, editChiller, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit chiller')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChillerDetail
            ac={acDetail}
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-chiller-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.chiller.errorMessage,
  isEditing: state.ac.chiller.isEditing,
  acDetail: props.ac && state.ac.chiller.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  editChiller: ac =>
    defaultRejectHandler(
      dispatch(
        editChiller(
          ac.id,
          ac.name,
          ac.type,
          ac.brand_id,
          ac.compressor_type || 'na',
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
        ),
      ),
    ),
  getChiller: id => defaultRejectHandler(dispatch(getChiller(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACCentralEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/ChillerEditModal.js